/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaLinkResponse } from '../../models/media-link-response';

export interface MediaControllerGetLinkToFile$Params {
  prefix: string;
  filename: string;
}

export function mediaControllerGetLinkToFile(http: HttpClient, rootUrl: string, params: MediaControllerGetLinkToFile$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaLinkResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerGetLinkToFile.PATH, 'get');
  if (params) {
    rb.query('prefix', params.prefix, {});
    rb.query('filename', params.filename, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaLinkResponse;
      }>;
    })
  );
}

mediaControllerGetLinkToFile.PATH = '/file-manager/link';
